import React, { useEffect } from "react";
import { ToastType } from "./ToastContext";

interface Props {
    message: string;
    type: ToastType;
    duration: number;
    onClose: () => void;
}

const Toast: React.FC<Props> = ({ message, type, duration, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(onClose, duration);
        return () => clearTimeout(timer);
    }, [duration, onClose]);

    return (
        <div className={`toast toast-${type}`}>
            {message}
        </div>
    );
};

export default Toast;
